import { ProductFeature } from '@/types/partnerConfig'

interface LocalisedProductFeature {
  [key: string]: ProductFeature
}

const CHECK_SYMPTOMS: LocalisedProductFeature = {
  enUS: {
    icon: 'ChatFilled',
    title: 'Check your symptoms right away',
  },
  esUS: {
    icon: 'ChatFilled',
    title: 'Compruebe sus síntomas inmediatamente',
  },
}
const BOOK_APPOINTMENT: LocalisedProductFeature = {
  enUS: {
    icon: 'PeopleMedicalSpecialist',
    title:
      'Book a video appointment to talk to a doctor 24 hours a day 7 days a week or a therapist Monday - Friday 7am-7pm',
  },
  esUS: {
    icon: 'PeopleMedicalSpecialist',
    title:
      'Programe una cita por video para hablar con un médico las 24 horas del día, los 7 días de la semana, o con un terapeuta de lunes a viernes, de 7 a. m. a 7 p. m.',
  },
}
const PRESCRIPTION: LocalisedProductFeature = {
  enUS: {
    icon: 'Medication',
    title: 'Get prescriptions sent to a local pharmacy of your choice',
  },
  esUS: {
    icon: 'Medication',
    title:
      'Sus medicamentos con receta se pueden enviar a la farmacia local que usted elija',
  },
}

const productFeatures: { [key: string]: ProductFeature[] } = {
  enUS: [CHECK_SYMPTOMS.enUS, BOOK_APPOINTMENT.enUS, PRESCRIPTION.enUS],
  esUS: [CHECK_SYMPTOMS.esUS, BOOK_APPOINTMENT.esUS, PRESCRIPTION.esUS],
}

export { CHECK_SYMPTOMS, BOOK_APPOINTMENT, PRESCRIPTION }
export default productFeatures
